import { Button, FormHelperText, Grid } from '@mui/material';

export const OptionsColumn = ({
  grid,
  value,
  options,
  question,
  onChange,
  ...rest
}) => {
  return (
    <Grid item className="options-column" xs={grid || 12}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={12} lg={6}>
          {question}
        </Grid>
        <Grid spacing={1} container item xs={12} lg={6} justifyContent="end">
          {options.split('\n').map((option) => (
            <Grid key={option} item xs={12} lg="auto">
              <Button
                onClick={() => onChange(option)}
                variant={value === option ? 'contained' : 'outlined'}
              >
                {option}
              </Button>
            </Grid>
          ))}
        </Grid>
        {rest.error ? (
          <Grid xs={12}>
            <FormHelperText>{rest.helperText}</FormHelperText>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};
